export default vm => ({
  generalData: {
    firstGeneralSection: [
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.type'),
        value: 'disconnectorType',
        enumLabelPrefix: 'enums.asset-info.polarity.',
      },
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.maneuver-type'),
        value: 'maneuverType',
        enumLabelPrefix: 'enums.asset-info.maneuver-type.',
      },
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.nominal-tension'),
        value: 'disconnectorNominalTension',
        precision: 2,
      },
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.nominal-chain'),
        value: 'disconnectorNominalChain',
        precision: 2,
      },
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.nominal-frequency'),
        value: 'disconnectorNominalFrequency',
        precision: 0,
      },
    ],
    supportableNominalTension: [
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.applied-voltage-1-min'),
        value: 'disconnectorAppliedTension1Min',
        precision: 0,
      },
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.atmospheric-impulse'),
        value: 'disconnectorAtmosphericImpulse',
        precision: 0,
      },
    ],
    secondGeneralSection: [
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.supportable-short-chain-duration'),
        value: 'disconnectorSupportableShortChainDuration',
      },
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.installation-place'),
        value: 'disconnectorInstallationPlace',
        enumLabelPrefix: 'enums.asset-info.installation-place.',
      },
      {
        text: vm.$t('fields.asset.asset-info.general-data.disconnector.maintenance-history'),
        value: 'disconnectorMaintenanceHistory',
      },
      {
        text: vm.$t('fields.general.observations'),
        value: 'disconnectorObservation',
      },
    ],
  },
});
